import React, { useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { assoc } from 'ramda';

import { Formik, Form } from 'formik';
import { Grid, Paper, Typography } from '@material-ui/core';
import Input from '../../../components/Input';
import Button from '../../../components/Button';

import { getPasswordStrength, getPasswordRules } from '../../../components/PasswordUpdate/resources';

import { verifyPasswordToken, resetPassword } from '../store/thunk';

import { validations } from './validations';

import { useStyles } from './styles';

const logo = require('../../../assets/img/logo-jump-icon.svg');

export default function PasswordReset() {
  const classes = useStyles();

  const dispatch = useDispatch();

  const history = useHistory();

  const isResale = !!process.env.REACT_APP_RESALE_ID;
  const resaleName = process.env.REACT_APP_RESALE_NAME;

  const { token, email } = useParams();

  const { isLoading } = useSelector(state => state.profile);
  const { name } = useSelector(state => state.profile.submit);

  const initialState = {
    password: '',
    passwordConfirm: ''
  }

  useEffect(() => {
    dispatch(verifyPasswordToken(token, email)).then(error => {
      if(error) {
        history.push('/');
      }
    });
  }, []);

  const handlePasswordReset = (values, actions) => {
    const { resetForm } = actions;
    const params = assoc('code', token, values);

    return dispatch(resetPassword(params)).then(error => {
      if (!error) {
        resetForm();
        history.push('/');
      }
    });
  }

  return(
    <Grid
      container
      spacing={0}
      alignItems="center"
      justify="center"
      className={classes.container}
    >
      <Grid item md={4} xs={12}>
        <Paper elevation={0} className={classes.paper}>
          <img
            src={isResale ? process.env.REACT_APP_RESALE_LOGIN_LOGO : logo}
            className="mb-4"
            width="100"
            height="auto"
            alt={isResale ? resaleName : 'Jump Park'}
          />
          <Typography paragraph variant="h6" color="primary">
            Olá
            <Typography
              variant="h5"
              color="primary"
              display="inline"
              className={classes.title}
            >
              {name && <>, {name}</>}
            </Typography>
            <br />
            Digite sua nova senha
          </Typography>
          <Formik
            initialValues={initialState}
            validationSchema={validations}
            onSubmit={(values, actions) => handlePasswordReset(values, actions)}
          >
            {({ ...formikProps }) => (
              <Form>
                <Grid container>
                  <Grid item xs={12}>
                    <Input
                      name="password"
                      type="password"
                      label="Senha"
                      placeholder="Senha"
                      value={formikProps.values.password}
                      error={formikProps.errors.password}
                      helperText={formikProps.errors.password}
                      onChange={formikProps.handleChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Input
                      name="passwordConfirm"
                      type="password"
                      label="Confirmar senha"
                      placeholder="Confirmar senha"
                      value={formikProps.values.passwordConfirm}
                      error={formikProps.errors.passwordConfirm}
                      helperText={formikProps.errors.passwordConfirm}
                      onChange={formikProps.handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: 10 }}>
                    {getPasswordStrength(formikProps.values.password || '')}
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    {getPasswordRules(formikProps.values.password || '')}
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      verticalGutter
                      loading={isLoading}
                      type="submit"
                      color="success"
                    >
                      Enviar nova senha
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
          <hr />
          <Link to="/">Voltar para o login</Link>
        </Paper>
      </Grid>
    </Grid>
  );
}